﻿const video = document.querySelector('#main-video');
const youtubeLink = document.querySelector('#youtubeLink');

document.addEventListener('DOMContentLoaded', () => { playVideo(false); })

export function playVideo() {
  if (!video) return;
  video.paused ? video.play() : video.pause();
}

export function endVideo() {
  fadeIn(youtubeLink);
  video.play();
}

function fadeIn(element) {
  element.classList.add('animate__fadeIn');
  element.classList.remove('animate__fadeOut');
}

function fadeOut(element) {
  element.classList.remove('animate__fadeIn');
  element.classList.add('animate__fadeOut');
}